<template>
  <div class="container-central">
    <h1 class="mt-5 mb-4">TESTIMONIOS</h1>

    <!-- Formulario crear / editar -->
    <b-card class="mb-4">
      <template #header>
        <strong>{{ editando ? 'Editar testimonio' : 'Nuevo testimonio' }}</strong>
      </template>
      <b-form @submit.prevent="guardar">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Cliente *" label-for="cliente">
              <b-form-input id="cliente" v-model="form.cliente" required placeholder="Nombre del cliente"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Sesionista *" label-for="sesionista">
              <b-form-input id="sesionista" v-model="form.sesionista" required placeholder="Ej: Ligia, Beatriz"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Servicio *" label-for="servicio">
              <b-form-input id="servicio" v-model="form.servicio" required placeholder="Ej: Tarot, Registros akáshicos"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <b-form-group label="Testimonio en Español *" label-for="mensaje_es">
          <b-form-textarea id="mensaje_es" v-model="form.mensaje_es" rows="3" required></b-form-textarea>
        </b-form-group>

        <b-form-group label="Testimonio en Inglés *" label-for="mensaje_en">
          <b-form-textarea id="mensaje_en" v-model="form.mensaje_en" rows="3" required></b-form-textarea>
        </b-form-group>

        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Orden" label-for="orden">
              <b-form-input id="orden" v-model.number="form.orden" type="number" min="0"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Fuente" label-for="fuente">
              <b-form-select id="fuente" v-model="form.fuente" :options="fuenteOpciones"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="URL reseña original (opcional)" label-for="url_fuente">
              <b-form-input id="url_fuente" v-model="form.url_fuente" placeholder="https://www.trustpilot.com/..."></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <b-form-checkbox v-model="form.activo" :value="1" :unchecked-value="0" class="mt-3">
              Visible
            </b-form-checkbox>
          </div>
        </div>

        <div class="d-flex justify-content-end" style="gap: 10px">
          <b-button v-if="editando" variant="outline-secondary" @click="cancelarEdicion">Cancelar</b-button>
          <b-button type="submit" variant="primary" :disabled="guardando">
            <b-spinner v-if="guardando" small class="mr-1"></b-spinner>
            {{ guardando ? 'Guardando...' : (editando ? 'Actualizar' : 'Crear testimonio') }}
          </b-button>
        </div>
      </b-form>
    </b-card>

    <!-- Listado -->
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <strong>Testimonios ({{ testimonios.length }})</strong>
          <b-spinner v-if="cargando" small></b-spinner>
        </div>
      </template>

      <b-table
        striped
        hover
        responsive="sm"
        :items="testimonios"
        :fields="campos"
        :busy="cargando"
        show-empty
        empty-text="No hay testimonios registrados"
      >
        <template #cell(activo)="data">
          <b-badge :variant="data.item.activo == 1 ? 'success' : 'secondary'">
            {{ data.item.activo == 1 ? 'Visible' : 'Oculto' }}
          </b-badge>
        </template>
        <template #cell(fuente)="data">
          <b-badge :variant="data.item.fuente === 'manual' ? 'light' : 'info'" style="border: 1px solid #ccc">
            {{ data.item.fuente }}
          </b-badge>
        </template>
        <template #cell(mensaje_es)="data">
          <span style="font-size: 0.85rem">{{ data.item.mensaje_es.substring(0, 80) }}{{ data.item.mensaje_es.length > 80 ? '...' : '' }}</span>
        </template>
        <template #cell(url_fuente)="data">
          <a v-if="data.item.url_fuente" :href="data.item.url_fuente" target="_blank" rel="noopener">
            <b-icon icon="box-arrow-up-right"></b-icon>
          </a>
          <span v-else class="text-muted">-</span>
        </template>
        <template #cell(actions)="data">
          <div style="display: flex; gap: 12px">
            <b-icon icon="pencil" variant="warning" @click="iniciarEdicion(data.item)" scale="1.4" style="cursor: pointer" v-b-tooltip.hover title="Editar"></b-icon>
            <b-icon
              :icon="data.item.activo == 1 ? 'eye-slash' : 'eye'"
              :variant="data.item.activo == 1 ? 'secondary' : 'success'"
              @click="toggleActivo(data.item)"
              scale="1.4"
              style="cursor: pointer"
              v-b-tooltip.hover
              :title="data.item.activo == 1 ? 'Ocultar' : 'Mostrar'"
            ></b-icon>
            <b-icon icon="trash" variant="danger" @click="confirmarEliminar(data.item)" scale="1.4" style="cursor: pointer" v-b-tooltip.hover title="Eliminar"></b-icon>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong style="margin-left: 5px">Cargando...</strong>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import TestimoniosService from "@/services/testimonios.service";
import EventBus from "@/services/eventBus.js";

export default {
  name: "TestimoniosAdmin",
  data() {
    return {
      testimoniosService: null,
      testimonios: [],
      cargando: false,
      guardando: false,
      editando: false,
      itemSeleted: null,
      from: "testimoniosadmin",
      form: this.formVacio(),
      fuenteOpciones: [
        { value: "manual", text: "Manual" },
        { value: "trustpilot", text: "TrustPilot" },
        { value: "google", text: "Google" },
      ],
      campos: [
        { key: "orden", label: "#", sortable: true },
        { key: "cliente", label: "Cliente", sortable: true },
        { key: "sesionista", label: "Sesionista", sortable: true },
        { key: "servicio", label: "Servicio", sortable: true },
        { key: "mensaje_es", label: "Testimonio (ES)" },
        { key: "fuente", label: "Fuente" },
        { key: "url_fuente", label: "Link" },
        { key: "activo", label: "Estado" },
        { key: "actions", label: "Acciones" },
      ],
    };
  },
  created() {
    this.testimoniosService = new TestimoniosService();
  },
  mounted() {
    this.cargar();
    EventBus.$on("RESPONSE_MODAL_QUESTION", (payLoad) => {
      if (payLoad.from === this.from && payLoad.action === "delete") {
        this.ejecutarEliminar();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("RESPONSE_MODAL_QUESTION");
  },
  methods: {
    formVacio() {
      return {
        id: null,
        cliente: "",
        sesionista: "",
        servicio: "",
        mensaje_es: "",
        mensaje_en: "",
        activo: 1,
        orden: 0,
        fuente: "manual",
        url_fuente: "",
      };
    },
    cargar() {
      this.cargando = true;
      this.testimoniosService
        .getTestimoniosAdmin()
        .then((res) => { this.testimonios = res.data.data || []; })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", { title: "Error", variant: "danger", message: "Error al cargar testimonios" });
        })
        .finally(() => { this.cargando = false; });
    },
    guardar() {
      this.guardando = true;
      const accion = this.editando
        ? this.testimoniosService.editarTestimonio(this.form)
        : this.testimoniosService.crearTestimonio(this.form);

      accion
        .then((res) => {
          if (res.data.status === 200) {
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Éxito",
              variant: "success",
              message: this.editando ? "Testimonio actualizado" : "Testimonio creado",
            });
            this.cancelarEdicion();
            this.cargar();
          }
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", { title: "Error", variant: "danger", message: "Error al guardar testimonio" });
        })
        .finally(() => { this.guardando = false; });
    },
    iniciarEdicion(item) {
      this.editando = true;
      this.form = {
        id: item.id,
        cliente: item.cliente,
        sesionista: item.sesionista,
        servicio: item.servicio,
        mensaje_es: item.mensaje_es,
        mensaje_en: item.mensaje_en,
        activo: item.activo,
        orden: item.orden,
        fuente: item.fuente,
        url_fuente: item.url_fuente || "",
      };
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    cancelarEdicion() {
      this.editando = false;
      this.form = this.formVacio();
    },
    toggleActivo(item) {
      const payload = { ...item, activo: item.activo == 1 ? 0 : 1 };
      this.testimoniosService.editarTestimonio(payload).then((res) => {
        if (res.data.status === 200) {
          item.activo = payload.activo;
        }
      });
    },
    confirmarEliminar(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Eliminar testimonio",
        messageModal: `¿Seguro desea eliminar el testimonio de "${item.cliente}"?`,
        action: "delete",
        from: this.from,
      });
    },
    ejecutarEliminar() {
      if (!this.itemSeleted) return;
      this.testimoniosService.eliminarTestimonio(this.itemSeleted.id).then((res) => {
        if (res.data.status === 200) {
          this.testimonios = this.testimonios.filter((t) => t.id !== this.itemSeleted.id);
          this.itemSeleted = null;
          EventBus.$emit("MOSTRAR_TOAST", { title: "Eliminado", variant: "success", message: "Testimonio eliminado" });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-central {
  width: 100%;
  min-height: 700px;
  padding: 0 20px 40px;
}
</style>
